import html2Canvas from 'html2canvas'
import Jspdf from 'jspdf'
export function savePdf(el, pdfName) {
  html2Canvas(el, {}).then(function(canvas) {
    var contentWidth = canvas.width
    var contentHeight = canvas.height
    var pageHeight = contentWidth / 592.28 * 841.89
    var leftHeight = contentHeight
    // 页面偏移
    var position = 0
    // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28
    var imgHeight = 595.28 / contentWidth * contentHeight

    var pageData = canvas.toDataURL('image/jpeg', 1.0)
    var pdf = new Jspdf('', 'pt', 'a4')
    // 放大会清晰一点
    pdf.internal.scaleFactor = 1.33
    // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
    // 当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
      pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
      while (leftHeight > 0) {
        pdf.addImage(pageData, 'JPEG', 0, position + 0, imgWidth, imgHeight)
        leftHeight -= pageHeight
        position -= 841.89
        // 避免添加空白页
        if (leftHeight > 0) {
          pdf.addPage()
        }
      }
    }
    pdf.save(`${pdfName}.pdf`)
  })
}
export function savePdfImgs(arr, pdfName, callback) {
  var pdf = new Jspdf('landscape', 'pt', 'a4')
  pdf.internal.scaleFactor = 2
  // arr.map((v, index) => {
  //   console.info(index)

  // })
  // for (let index = 0; index < arr.length; index++) {
  //   const v = arr[index]

  // }
  let index = 0
  const func = () => {
    const v = arr[index]
    html2Canvas(v, {
      useCORS: true,
      scale: 2
    }).then(function(canvas) {
      var contentWidth = canvas.width
      var contentHeight = canvas.height
      console.info(contentHeight)
      // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      var imgWidth = 841.89
      var imgHeight = 841.89 / contentWidth * contentHeight
      var pageData = canvas.toDataURL('image/jpeg', 1.0)
      index !== 0 ? pdf.addPage() : ''
      // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      // 当内容未超过pdf一页显示的范围，无需分页
      pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
      if (index === arr.length - 1) {
        pdf.save(`${pdfName}.pdf`)
      } else {
        index++
        func()
      }
      if (index === arr.length - 1) {
        if (callback) {
          callback()
        }
      }
    })
  }
  func()
}
